import React from 'react';
import styled from 'styled-components';
import { Row, Col } from 'antd';
import { range } from 'lodash';
import { Calendar } from 'tmt-ui-kit';

import { FormTitle, RadioGroupButton, Dropdown, Label, Checkbox } from 'components/Core/Forms';
import { dateString } from 'utils/helpers';
import { getChildPriceObj, isMultiTier, isRequireDate, getHotelObj } from 'utils/product';

const { BookCalendar: _BookCalendar } = Calendar;

const SubTierContainer = styled.div`
  margin-bottom: 15px;
`;

const SubTierRowContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
  p {
    flex: 2;
  }
  > * {
    flex: 1;
  }
`;

const Date = styled.span`
  font-weight: normal;
`;

const CalendarContainer = styled.div`
  padding: 8px;
  width: fit-content;
  width: -moz-fit-content;
  width: -webkit-fit-content;
  border: 1px solid ${props => props.theme.lightGray1};
  border-radius: 4px;
`;
const BookCalendar = styled(_BookCalendar)`
  margin: 0 0;
  box-sizing: border-box;
`;


const generateMaxQuantity = (maxTravelers, from = 1) => range(from, maxTravelers + 1).map(num => ({ label: num, value: num }));

const getSelectedTier = (multiTier, currentTier) => multiTier.find(t => t.tier === currentTier);

const BookForm = props => {
  const { product, book, currentDate, onChange, showCalendar, tripAvailabilities, loading } = props;
  const childPrice = getChildPriceObj(product.additional_options);
  const hotelObj = getHotelObj(product.additional_options);
  let childOptions = [];
  if (childPrice) {
    childOptions = generateMaxQuantity(product.max_travelers - book.quantity, 0);
  }
  const selectedTierObj = isMultiTier(product) ? getSelectedTier(product.multi_tier_prices, book.selectedTier) : null;
  let productDateLabel = 'Trip date';
  let productQuantityLabel = 'Guest(s)';
  if (product.product_type === 'souvenir') {
    productDateLabel = 'Delivery date';
    productQuantityLabel = 'Quantity';
  }
  if (product.product_type === 'ticket') productDateLabel = 'Visit date';
  return [
    <FormTitle>Select date and quantity</FormTitle>,
    isMultiTier(product) ? (
      <div>
        <RadioGroupButton
          label="Select package"
          options={product.multi_tier_prices
            .map(tier => ({ label: tier.tier, value: tier.tier }))
          }
          onChange={e => onChange('selectedTier', e.target.value)}
        />
        {selectedTierObj && (
          <SubTierContainer>
            <Label>Specify quantity</Label>
            {selectedTierObj.sub_tiers.map((subTier, index) => (
              <SubTierRowContainer>
                <p>{subTier.name} <b>(THB {subTier.price})</b></p>
                <Dropdown
                  options={generateMaxQuantity(12, 0)}
                  noMargin
                  value={book.subTier[index]}
                  onChange={v => onChange(`subTier.${index}`, v)}
                />
              </SubTierRowContainer>
            ))}
          </SubTierContainer>
        )}
      </div>
    ) : product.product_type !== 'car_rental' && (
      <Row gutter={16}>
        <Col span={childPrice ? 12 : 24}>
          <Dropdown
            label={childPrice ? 'Adult' : productQuantityLabel}
            options={generateMaxQuantity(product.max_travelers)}
            onChange={v => onChange('quantity', v)}
            value={book.quantity}
          />
        </Col>
        {childPrice && (
          <Col span={12}>
            <Dropdown
              label="Child (Age 2-12)"
              options={childOptions}
              onChange={v => onChange('childQuantity', v)}
              value={book.childQuantity}
            />
          </Col>
        )}
      </Row>
    ),
    hotelObj ? (
      <div>
        <Label>
          <Checkbox checked={book.hotelQuantity > 0} onChange={v => onChange('hotelQuantity', v.target.checked ? 1 : 0)} />
          {` ${hotelObj.title}`}{` +${hotelObj.price} ${hotelObj.currency}`}
        </Label>
      </div>
    ) : null,
    isRequireDate(product) ? (
      <div>
        {showCalendar && [
          <Label>
            {productDateLabel}{book.date ? <Date>: {dateString(book.date.date, 'date')}</Date> : ''}
          </Label>,
          <CalendarContainer>
            <BookCalendar
              currentDate={currentDate}
              onChange={date => onChange('date', date[0])}
              onChangeMonthYearCallback={props.onChangeMonthYear}
              tripAvailabilities={tripAvailabilities}
              loading={loading}
            />
          </CalendarContainer>
        ]}
      </div>
    ) : null
  ];
};

export default BookForm;



// WEBPACK FOOTER //
// ./src/components/Form/BookForm.js